import { render, staticRenderFns } from "./FormatMessage.vue?vue&type=template&id=934b3d7e&"
import script from "./FormatMessage.vue?vue&type=script&lang=js&"
export * from "./FormatMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports